import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, ArrowUpRight } from "lucide-react";
import { CONTACT } from "../data/site";

export const Footer = () => (
  <footer data-testid="main-footer" className="relative bg-black border-t border-white/10 overflow-hidden">
    <div className="grid-lines absolute inset-0 opacity-40" />
    <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 py-16 sm:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <img src="/logo-dark.png" alt="Renewolt Enerji" className="h-12 w-auto object-contain mb-6" />
          <p className="text-neutral-400 text-sm leading-relaxed max-w-sm">
            Güneşin gücünü mühendislik hassasiyetiyle enerjiye dönüştürüyoruz. Çatıdan araziye,
            öz tüketimden şarj istasyonuna sürdürülebilir enerji çözümleri.
          </p>
          <a
            href={CONTACT.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-2 mt-6 text-sm text-neutral-300 hover:text-[#5CC528] transition-colors"
          >
            <Instagram size={18} /> {CONTACT.instagram}
          </a>
        </div>

        <div className="lg:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#5CC528] mb-5">Menü</h4>
          <ul className="space-y-3 text-sm">
            {[
              { to: "/hizmetler", label: "Hizmetler" },
              { to: "/hesaplama", label: "GES Hesaplama" },
              { to: "/projeler", label: "Projeler" },
              { to: "/hakkimizda", label: "Hakkımızda" },
              { to: "/iletisim", label: "İletişim" },
            ].map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-neutral-400 hover:text-white transition-colors inline-flex items-center gap-1 group">
                  {l.label}
                  <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#5CC528] mb-5">İletişim</h4>
          <ul className="space-y-4 text-sm">
            <li>
              <a href={`mailto:${CONTACT.email}`} className="flex items-start gap-3 text-neutral-400 hover:text-white transition-colors">
                <Mail size={18} className="text-[#5CC528] mt-0.5 shrink-0" /> {CONTACT.email}
              </a>
            </li>
            <li>
              <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-start gap-3 text-neutral-400 hover:text-white transition-colors">
                <Phone size={18} className="text-[#5CC528] mt-0.5 shrink-0" /> {CONTACT.phone}
              </a>
            </li>
            <li className="flex items-start gap-3 text-neutral-400">
              <MapPin size={18} className="text-[#5CC528] mt-0.5 shrink-0" /> {CONTACT.address}
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-neutral-500">
          © {new Date().getFullYear()} Renewolt Enerji | Mühendislik. Tüm hakları saklıdır.
        </p>
        <p className="text-xs text-neutral-500">{CONTACT.website}</p>
      </div>
    </div>
  </footer>
);
